import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import i18n from "./DropdownLanguage/i18n";
import "./UserManagementMaster.css";

class UsersCard extends React.Component {
  getTotalPages() {
    const { pageSize, totalRecords } = this.props;
    return Math.max(1, Math.ceil(totalRecords / pageSize));
  }

  getVisiblePages(currentPage, totalPages) {
    const maxButtons = 5;
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + maxButtons - 1);

    if (end - start + 1 < maxButtons) {
      start = Math.max(1, end - maxButtons + 1);
    }

    const pages = [];
    for (let page = start; page <= end; page += 1) {
      pages.push(page);
    }
    return pages;
  }

  handlePageChange(page) {
    const { setUpdatedState } = this.props;
    const totalPages = this.getTotalPages();
    if (page < 1 || page > totalPages) {
      return;
    }
    setUpdatedState(page);
  }

  getAdminBadgeClass(isAdmin) {
    return isAdmin
      ? "um-admin-badge um-admin-yes"
      : "um-admin-badge um-admin-no";
  }

  getAdminLabel(isAdmin, t) {
    if (isAdmin === true) {
      return t("MMPLUserManagementContent.True");
    }
    if (isAdmin === false) {
      return t("MMPLUserManagementContent.False");
    }
    return "-";
  }

  renderListLabel(label, iconClass) {
    return (
      <span className="um-field-label um-list-label">
        <i className={`fa ${iconClass} um-list-label-icon`} aria-hidden="true"></i>
        <span>{label}</span>
      </span>
    );
  }

  renderField(
    label,
    value,
    iconClass,
    isArabic = false,
    extraClass = "",
    title = "",
    withDivider = false
  ) {
    return (
      <div
        className={`um-field-cell ${extraClass} ${
          withDivider ? "um-field-with-divider" : ""
        }`}
      >
        {this.renderListLabel(label, iconClass)}
        <span
          className={`um-field-value ${isArabic ? "arabic" : ""}`}
          title={title || undefined}
        >
          {value || "-"}
        </span>
      </div>
    );
  }

  renderPagination() {
    const { currentPage, pageSize, totalRecords, t } = this.props;
    if (!totalRecords) {
      return null;
    }

    const totalPages = this.getTotalPages();
    const startRecord = (currentPage - 1) * pageSize + 1;
    const endRecord = Math.min(currentPage * pageSize, totalRecords);
    const visiblePages = this.getVisiblePages(currentPage, totalPages);

    return (
      <div className="um-pagination">
        <div className="um-pagination-info">
          {t("MMPLUserManagementContent.Showing")}{" "}
          <strong>{startRecord}</strong>{" "}
          {t("MMPLUserManagementContent.To")}{" "}
          <strong>{endRecord}</strong>{" "}
          {t("MMPLUserManagementContent.Of")}{" "}
          <strong>{totalRecords}</strong>
        </div>
        {totalPages > 1 ? (
          <div className="um-pagination-controls">
            <button
              type="button"
              className="um-page-btn"
              onClick={() => this.handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              aria-label={t("MMPLUserManagementContent.Previous")}
            >
              <i className="fa fa-chevron-left" aria-hidden="true"></i>
            </button>
            {visiblePages.map((page) => (
              <button
                key={page}
                type="button"
                className={`um-page-btn ${currentPage === page ? "is-active" : ""}`}
                onClick={() => this.handlePageChange(page)}
              >
                {page}
              </button>
            ))}
            <button
              type="button"
              className="um-page-btn"
              onClick={() => this.handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              aria-label={t("MMPLUserManagementContent.Next")}
            >
              <i className="fa fa-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
        ) : null}
      </div>
    );
  }

  renderCardData() {
    const { arraylist, deleteUserList, eyeclick, t } = this.props;
    const isArabic = i18n.language === "arab";

    return arraylist && arraylist.length
      ? arraylist.map((item) => (
          <div key={item.userId || item.email} className="um-user-card">
            <div className="um-user-card-inner">
              <div className="um-user-card-row um-user-card-row-mmpl">
                <div className="um-user-fields um-user-fields-mmpl">
                  {this.renderField(
                    t("MMPLUserManagementContent.UserId"),
                    item.email,
                    "fa-envelope-o",
                    isArabic,
                    "um-field-email",
                    item.email
                  )}
                  <div className="um-field-cell um-field-admin um-field-with-divider">
                    {this.renderListLabel(
                      t("MMPLUserManagementContent.IsAdmin"),
                      "fa-shield"
                    )}
                    <span className={this.getAdminBadgeClass(item.isAdmin)}>
                      {this.getAdminLabel(item.isAdmin, t)}
                    </span>
                  </div>
                </div>
                <div className="um-user-actions">
                  <button
                    type="button"
                    className="um-action-btn"
                    onClick={() => eyeclick(item)}
                    aria-label={t("IntervelScreen.Edit")}
                  >
                    <i className="fa fa-pencil" aria-hidden="true"></i>
                  </button>
                  <button
                    type="button"
                    className="um-action-btn um-delete-btn"
                    onClick={() => deleteUserList(item)}
                    aria-label={t("content.Delete")}
                  >
                    <i className="fa fa-trash" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))
      : null;
  }

  render() {
    const { arraylist, t } = this.props;

    return (
      <div className="user-module-master pb-1">
        {this.renderCardData()}
        {arraylist && arraylist.length ? (
          this.renderPagination()
        ) : (
          <div className="um-empty-state">
            <div>
              <i className="fa fa-user" aria-hidden="true"></i>
            </div>
            <div>{t("MMPLUserManagementContent.NoRecordsFound")}</div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(UsersCard))
);
